import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const RootWrapper = styled(Box)(({ theme }) => ({
  paddingLeft: 32,
  paddingRight: 32,
  [theme.breakpoints.down("md")]: {
    padding: 0,
  },
}));

export const ContentWrapper = styled(Box)({});
